import constant from '../../constant';
import request from "../../../utils/request";
import querystring from 'query-string';
import {GET_CLIPBOARD} from "../../../urls";

// const getClipboard = async (params = {}) => {
//   try {
//     const result = await request.complicatedPost({
//       url: 'https://upage.html5.qq.com/ug-aes-encrypt',
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded'
//       },
//       credentials: 'include',
//       method: 'POST',
//       data: querystring.stringify({
//         url: params.url || window.targetUrl,
//       })
//     })
//
//     if (result.code === 0) {
//       params.clipboardData = result.data;
//     }
//   }catch (e) {
//     console.log('getClipboard err', e);
//   }
//   return {
//     type: constant.E_COMMERCE_FISSION.CLIPBOARD,
//     ...params
//   }
// }

const getClipboard = (params = {}) => {
  return async (dispatch) => {
    try {
      const result = await request.complicatedPost({
        url: GET_CLIPBOARD,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        credentials: 'include',
        method: 'POST',
        data: querystring.stringify({
          url: params.url || window.targetUrl,
        })
      });

      if (result.code === 0) {
        params.clipboardData = result.data;
        dispatch(getClipboardSuccess({clipboardData: result.data}))
      }
    }catch (e) {
      console.log('getClipboard err', e);
    }
  }
}

const getClipboardSuccess = (clipboard) => {
  return {
    type: constant.E_COMMERCE_FISSION.CLIPBOARD,
    ...clipboard
  }
}
export default {
  getClipboard
}